import React from 'react';
import styled from "styled-components";
import {Condition} from "../../../ui";


const FooterRoot = styled.div`
    max-width: 383px;
    margin: 80px auto;
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		justify-content: flex-start;
		min-height: 205px;
    @media screen and (max-width: 640px) {
        max-width: 327px;
        margin: 40px auto;
    }
    @media screen and (max-width: 320px) {
        max-width: 300px;
    }
`

const Link = styled.a`
		margin: 0 21px 10px 0;
		font-weight: 400;
    font-size: 14px;
`

const Footer = ({ items, lang }) => {
	return (
		<FooterRoot>
			<Condition match={items?.length > 0}>
				{
					items.map((i) => {
						return (
							<Link key={i.href} href={i.href?.(lang)} target="_self" rel="noreferrer">
								{i?.[lang]}
							</Link>
						)
					})
				}
			</Condition>
		</FooterRoot>
	);
};

export default Footer;
